import React from 'react';
const stats = [{
  value: '+1.800',
  label: 'estudiantes confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'LM',
  quote: '"Tenía Biomecánica y Evaluación Kinésica en 3 semanas y no sabía por dónde empezar. Con el Megapack encontré todo organizado por región, con los tests y los protocolos paso a paso. Aprobé con 9."',
  author: '— Lucía M., Córdoba | 3° año Kinesiología UNC'
}, {
  initials: 'FS',
  quote: '"Lo que más me sirvió fue el Bono de Supervivencia Hospitalaria. Llegué a la rotación sabiendo exactamente cómo leer los signos vitales y manejarme en la UTI sin que me agarrara el pánico frente al paciente."',
  author: '— Franco S., Buenos Aires | 4° año Kinesiología UBA'
}, {
  initials: 'VP',
  quote: '"Antes juntaba apuntes de 10 compañeros distintos y nada coincidía. El Megapack tiene todo en un solo lugar, con el lenguaje que piden en los exámenes. Ya aprobé 5 materias con él."',
  author: '— Valentina P., Rosario | 3° año Kinesiología UNR'
}];
export function SocialProof() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(239,246,255) 50%, rgb(255,255,255) 100%)'
  }} data-id="element-282">
      <div className="mx-auto max-w-4xl" data-id="element-283">
        {/* ── STATS GRID ── */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-284">
          {stats.map(stat => <div key={stat.label} data-id="element-285">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-286">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-blue-700" data-id="element-287">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* ── TESTIMONIALS GRID ── */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-288">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white/80 border border-blue-400/30 rounded-lg p-3 shadow-sm" data-id="element-289">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-black text-blue-700" style={{
            background: 'linear-gradient(135deg, rgba(29,78,216,0.12) 0%, rgba(59,130,246,0.12) 100%)'
          }} data-id="element-290">
                {t.initials}
              </div>
              <div data-id="element-291">
                <div className="mb-1 text-[10px] text-blue-600" data-id="element-292">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-293">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-294">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}